export const ORDER_CONNECT_CONFIGS = [
	{
		name: '쿠팡이츠',
		state: 'print',
		state_title: '출력물 연동',
		sub: '주문전표가 출력되면 배달매니저에 주문이 생성돼요'
	},
	{
		name: '배달특급',
		state: 'print',
		state_title: '출력물 연동',
		sub: '주문전표가 출력되면 배달매니저에 주문이 생성돼요'
	},
	{
		name: '대구로',
		state: 'print',
		state_title: '출력물 연동',
		sub: '주문전표가 출력되면 배달매니저에 주문이 생성돼요'
	},
	{
		name: '인천이음',
		state: 'print',
		state_title: '출력물 연동',
		sub: '주문전표가 출력되면 배달매니저에 주문이 생성돼요'
	},
	{
		name: '배달양산',
		state: 'print',
		state_title: '출력물 연동',
		sub: '주문전표가 출력되면 배달매니저에 주문이 생성돼요'
	},
]

